import Swal from 'sweetalert2';
import dateUtils from '../util/dateUtil';
import promiseUtils from '../util/promiseUtils';
import util from '../util';
import strings from "../Globalization";
import connectionService from '../services/Connection';


const ACTION_STATUSES = ['START', 'SUCCESS', 'ERROR'];

const defaultHandlers = {
	START: function (state, action, options) {
		return Object.assign({}, state, { isFetching: true, error: null, callAction: action.options.action || '' });
	},
	SUCCESS: function (state, action, options) {
		const dateFields = options ? options.dateFields : [];
		if (dateFields && dateFields.length > 0 && action.json && action.json.records) {
			const records = action.json.records;

			if (Array.isArray(records)) {
				for (let i = 0, len = records.length; i < len; i++) {
					let record = records[i];
					for (let j = 0, count = dateFields.length; j < count; j++) {
						record[dateFields[j]] = dateUtils.parse(record[dateFields[j]]);
					}
				}
			}
		}
		return Object.assign({}, state, { data: action.json, isFetching: false, type: action.type, error: null, callAction: action.options.action || '' });
	},

	ERROR: function (state, action, options) {
		const { response } = action;
		let errorMessage = '';
		if (typeof response === 'object' && response.status) {
			errorMessage = strings[`Status_${response.status}`]
		}
		else {
			errorMessage = strings.CheckNetwork;
		}
		Swal.fire({ titleText: strings.ErrorTitle, text: errorMessage, icon: 'error', confirmButtonText: strings.Ok, allowOutsideClick: false });

		return Object.assign({}, state, { isFetching: false, error: errorMessage, callAction: action.options.action || '', data: {} });
	}
};

export default class AjaxAction {
	constructor(options) {
		Object.assign(this, options);
		let requestType = options.requestType;
		let actionTypes = {};
		let actions = {};
		let statuses = [].concat(ACTION_STATUSES);
		if (options.otherActionTypes) {
			statuses = statuses.concat(options.otherActionTypes)
		}
		for (const status of statuses) {
			const action = requestType + '_' + status
			actionTypes[requestType + '_' + status] = action;
			actions[status] = action;
		}
		this.actionTypes = actionTypes;
		this.actions = actions;
		this.reducer = this._createReducer(options);
	}

	_createReducer(options) {
		const requestType = options.requestType;

		let actions = options.actions || ACTION_STATUSES;

		const validActions = [];

		actions.map((action) => {
			const actionName = requestType + '_' + action;
			validActions.push(actionName);
			return true;
		});

		for (const o in options.otherHandlers) {
			validActions.push(requestType + '_' + o);
		}

		let parser = this._createDefaultParser(options, actions);

		return function (state = { isFetching: false, data: null }, action) {
			if (validActions.indexOf(action.type) > -1) {
				return Object.assign({}, state, parser(state, action));
			}
			return state;
		}
	}

	_createDefaultParser(options, actions) {

		const customHandlers = Object.assign({}, defaultHandlers, options.handlers, options.otherHandlers);

		let handlerMap = {};

		for (const action in customHandlers) {
			const key = options.requestType + '_' + action;
			handlerMap[key] = customHandlers[action];
		};

		return function (state = { isFetching: false, data: {} }, action) {
			if (typeof handlerMap[action.type] === 'function') {
				return handlerMap[action.type](state, action, options);
			} else {
				return state;
			}
		}
	}

	request(options, listState) {
		const listPrefToSave = listState ? util.clone(listState) : listState;
		if (listPrefToSave !== undefined && listPrefToSave.listId) {
			let prefListId = listPrefToSave.listId;
			if (listPrefToSave.listId && listPrefToSave.baseFilters !== undefined && listPrefToSave.baseFilters.length !== 0) {
				const baseFilters = listPrefToSave.baseFilters[0];
				if (window.location.hash.indexOf('id') !== -1) { // Changing ListId for id filters from hash
					prefListId = prefListId + baseFilters.column + baseFilters.value;
					listPrefToSave.listId = prefListId;
				}
			}
			this.jsonData = undefined;
			return (dispatch, getState) => {
				this.loadState(prefListId, listPrefToSave, options, dispatch); // loading preference by prefrence listId with Data
			}
		}
		else {
			return (dispatch, getState) => {
				return dispatch(this._fetch(options, listPrefToSave))
			}
		}
	}

	_onStart(options) {
		return {
			type: this.actions.START,
			options
		}
	}

	_onSuccess(options, json) {
		return {
			type: this.actions.SUCCESS,
			options,
			json,
			receivedAt: Date.now()
		}
	}

	_onFailure(options, response) {
		return {
			type: this.actions.ERROR,
			options,
			response,
			receivedAt: Date.now()
		}
	}

	_onSessionExpire(options, response, scope, msg) {
		const IsLoggedOut = localStorage.getItem('IsLoggedOut');
		if (IsLoggedOut) {
			return;
		}
		const isSessionExpired = JSON.parse(util.localData.isSessionExpired);
		window.queuedScope = scope;
		if (isSessionExpired || msg) {
			util.clearLocalStorage();
			Swal.fire({
				titleText: strings.SessionTitle,
				text: msg || strings.SessionMessage,
				icon: "input",
				input: "password",
				showCancelButton: true,
				closeOnConfirm: false,
				animation: "slide-from-top",
				confirmButtonText: strings.Ok,
				cancelButtonText: strings.Cancel,
				inputPlaceholder: strings.Password,
				inputAttributes: {
					"autocomplete": "new-password"
				},
				allowOutsideClick: false
			}).then((inputValue) => {
				if (inputValue === false) {
					window.location.href = '#/login';
					return false;
				}
				if (inputValue === "") {
					Swal.showValidationMessage(strings.PasswordMissing);
					return false
				}
				const userName = util.localData.username;
				util.continueSession(userName, inputValue);
			});
		}
	}

	_invalidLicense(options, response, scope, msg) {
		Swal.fire({
			titleText: strings.LicenceWarning || 'License Warning',
			html: `${strings.LicenceMissing || 'Machine Key'} <br/><br/> ${response.MachineKey}`,
			cancelButtonText: strings.Copy || 'Copy',
			showCancelButton: true,
			closeOnConfirm: true,
			closeOnCancel: false,
			animation: "slide-from-top",
			confirmButtonText: strings.Ok || 'Ok',
			type: "input",
			input: "file",
			inputAttributes: {
				"accept": ".lic, .zip"
			},
			allowOutsideClick: false
		}).then((isConfirm) => {
			if (!isConfirm && typeof isConfirm === 'boolean') {
				util.copyText(response.MachineKey);
				Swal.fire({ titleText: strings.Copied || 'Copied' , confirmButtonText: strings.Ok});
			} else {
				scope._uploadLicense(isConfirm, scope, response)
			}
		});
	}

	_errorMsg(response, scope) {
		Swal.fire({ icon: "error", title: "Error", text: strings.InvalidLicenseFile, confirmButtonText: strings.Ok, allowOutsideClick: false }).then(() => {
			scope._invalidLicense(null, response, scope, null)
		});
	}

	_uploadLicense(file, scope, response) {
		const licFile = document.querySelectorAll('[type=file]')[1].files[0]
		if (!licFile) {
			Swal.fire({ icon: "info", title: "Info", text: strings.PleaseSelectLicensePath , confirmButtonText: strings.Ok, allowOutsideClick: false}).then(() => {
				scope._invalidLicense(null, response, scope, null)
			});
		} else
			fetch(connectionService.Config, {
				method: 'POST', body: scope._getFormData({
					action: 'uploadLicense',
					licFile,
				}, false)
			}).then((res) => {
				res.text().then(text => {
					const json = util.unsafeJson(text);
					if (json.success) {
						Swal.fire({ icon: "success", titleText: "Success", text: strings.LicenseUpdatedSuccessfully , confirmButtonText: strings.Ok, allowOutsideClick: false})
						window.location.reload()
					} else {
						scope._errorMsg(response, scope)
					}
				})
			}).catch(() => {
				scope._errorMsg(response, scope)
			})
	}

	_getFormData(props) {
		const formData = new FormData();
		if (this.useToken !== false) {
			formData.append('authToken', sessionStorage.getItem('authToken'));
		}
		for (const key in props) {
			if (key !== 'avatar'){
				formData.append(key, props[key]);
			}
		}
		return formData;
	}
	_successResponse(options, response, me, dispatch) {
		response.text().then(function (text) {
			let json = util.unsafeJson(text);
			if (!json.success) {
				if (json.info === 'Session has expired!' && !window.location.hash.includes('#/login')) {
					util.localData.isSessionExpired = true;
					me._onSessionExpire(options, response, me);
					return false;
				}
				if (json.info === "Invalid License file") {
					me._invalidLicense(options, json, me);
					return false;
				}
			}
			if (me.jsonData !== undefined) {
				options.prefState = me.jsonData;
			}
			dispatch(me._onSuccess(options, json));
		})
	}
	_serverError(options, response, me, dispatch) {
		if (response.status === 403) {
			Swal.fire({
				title: strings.Alert,
				text: strings.AccessError,
				showCancelButton: false,
				confirmButtonText: strings.Ok,
				confirmButtonClass: "btn-danger",
				closeOnConfirm: true,
				allowOutsideClick: false
			}).then(() => {
				window.location.hash = '/dashboard';
			});
			return false;
		}
		else {
			dispatch(me._onFailure(options, response));
		}
	}
	statusMappingFn = {
		'status_200': this._successResponse,
		'status_500': this._serverError,
		'status_503': this._serverError,
		'status_403': this._serverError,
	}
	loadState(listId, listState, options, dispatch) {
		const formData = new FormData();
		formData.append('id', listId);
		formData.append('action', 'list');
		const me = this;
		const timeout = 60000;
		me.options = options;
		let p = fetch(connectionService.GridPreferenceManager,
			{
				method: 'POST',
				body: formData,
				credentials: 'include'
			});

		p = promiseUtils.makeCancelable(p, timeout);
		me.lastFetch = p;
		return p.promise.then(response => {
			me.lastFetch = null;
			let json;
			if (response.status === 200) {
				response.text().then(function (text) {
					let options = me.options;
					try {
					 json = util.unsafeJson(text);
					} catch (e) {
						Swal.fire({ titleText: strings.ErrorTitle, text: strings.ErrorUpdate, icon: 'error', confirmButtonText: strings.Ok, allowOutsideClick: false })
					}
					if (!json.success) {
						if (json.info === 'Login failed' || json.info === 'Session has expired!') {
							util.localData.isSessionExpired = true;
							me._onSessionExpire(options, response, me);
							return false;
						}
					}
					if (!json.preferences) {
						return false;
					}
					const listPreference = json.preferences[0];
					me.jsonData = {};
					if (listPreference !== undefined && listState.loadPref && listPreference.prefValue !== "") { // Loading default preference from DB
						const prefValue = util.unsafeJson(listPreference.prefValue);
						for (const rec in prefValue) {
							switch (rec) { // Ignored Options from prefrence
								case "columns":
								case "hiddenColumns":
								case "baseFilters":
								case "activeRecord":
								case "gridPreference":
								case "rows":
								case "filters":
								case "totalRecords":
								case "showModal":
								case "showPrefWin":
								case "doctitle":
								case "loading":
									break;
								case "extraParams":
									let extraParams = prefValue["extraParams"];
									for (let params in extraParams) { // Adding Extra params value from preference
										options[params] = extraParams[params];
									}
									break;
								case "sortColumn":
									options["sort"] = prefValue[rec];
									options["dir"] = prefValue["sortDir"];
									break;
								case "currentPage":
									options["page"] = prefValue[rec];
									break;
								case "pageSize":
									options["limit"] = prefValue[rec];
									break;
								default:
									options[rec] = prefValue[rec];
									break;
							}
							me.jsonData[rec] = prefValue[rec];
						}
						const baseFilters = listState.baseFilters;
						if (baseFilters.length) {
							const filters = JSON.parse(me.jsonData.filter || "[]");
							baseFilters.forEach(({ column }) => {
								if (options.filter.match(column) !== null && options.filter.match(column).length) {
									const baseFilterIndex = filters.findIndex(filterTerm => filterTerm.property === column)
									filters.pop(baseFilterIndex);
								}
							});
							me.jsonData.filter = JSON.stringify(filters);
						}
						//we need to process column so that we have new column then we can add that those on columns coming from Preference
						prefValue.columns = me.processColumn(listState.columns, prefValue.columns);
						listState = prefValue;
						me.jsonData.columns = prefValue.columns
					}
					if (options["page"] && options["page"] > 0 && options["limit"] && options["limit"] > 0) {
						options["start"] = (options["page"] * options["limit"]) - options["limit"] + (options.isFromDCPL ? 0 : 1);
						delete options.isFromDCPL;
					}
					me.jsonData.loadPref = false;
					listState.filter = options.filter;
					me.saveState(listState);
					return dispatch(me._fetch(options, listState))
				})
			} else {
				let processFunc = this.statusMappingFn[`status_${response.status}`]
				if (processFunc) {
					processFunc(options, response, me, dispatch);
				}
				else {
					dispatch(me._onFailure(options, response));
				}
			}
		}).catch(function (err) {
			me.lastFetch = null;
			dispatch(me._onFailure(options, err));
		});
	}

	processColumn(columns, prefColumns) {
		const newColumnList = [];
		columns && columns.forEach(function (columnInfo) {
			if (prefColumns) {
				const prefColumn = prefColumns.filter(data => data.key === columnInfo.key && data.type === columnInfo.type);
				if (prefColumn.length !== 0) {
					Object.keys(columnInfo).forEach(function (key) {
						if (key in prefColumn[0]) {
							columnInfo[key] = prefColumn[0][key];
						}
					});
				}
				newColumnList.push(columnInfo);
			}
		});
		return newColumnList;
	}

	saveState(listState) {
		let listPrefToSave = listState ? util.clone(listState) : listState;
		let listId = listPrefToSave?.listId;
		if (listId !== undefined) {
			delete listPrefToSave.listId;
			let processedPref = util.processGridState(listPrefToSave);
			let formData = new FormData();
			let loginData = util.localData.loginData;
			if (loginData !== undefined) {
				formData.append('clientId', loginData.tags.ClientId);
			}
			formData.append('id', listId);
			formData.append('prefId', 0);
			formData.append('prefName', 'statePreference');
			formData.append('isDefault', false);
			formData.append('prefDesc', 'statePreference');
			formData.append('prefValue', JSON.stringify(processedPref));
			formData.append('action', 'save');
			fetch(connectionService.GridPreferenceManager, {
				body: formData,
				method: 'POST',
				credentials: 'include'
			});
		}
	}
	_fetch(options, listState) {
		const me = this;
		if (me.lastFetch && me.cancelLastFetch) {
			me.lastFetch.cancel();
		}

		return dispatch => {
			dispatch(this._onStart(options))
			let timeout = 60000;
			if (options && options.timeout) {
				timeout = options.timeout;
			}
			let p = fetch(this.url, { method: 'POST', body: this._getFormData(options, false), credentials: 'include' });
			p = promiseUtils.makeCancelable(p, timeout);
			me.lastFetch = p;
			return p.promise.then(response => {
				me.lastFetch = null;
				let processFunc = this.statusMappingFn[`status_${response.status}`]
				if (processFunc) {
					processFunc(options, response, me, dispatch);
				}
				else {
					dispatch(me._onFailure(options, response));
				}
			}).catch(function (err) {
				me.lastFetch = null;
				dispatch(me._onFailure(options, err));
			});
		};
	}
}
